/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-24T17:21:47.016
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHousePic,
	listRentHousePicInit,
	listRentHousePicByAuthorizations,
	deleteRentHousePic
	
} from '@api/rentmanage/RentHousePic';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHousePic({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePic(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHousePicByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePicByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHousePicInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePicInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHousePic({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHousePic({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
